export default {
  book: {
    title: '订单确认',
    trainInfo: '车票信息',
    seatPreference: '座位偏好',
    passengerInfo: '乘客信息',
    bookingNotice: '预定前须知',
    paymentConfirmation: '支付前确认事项',
    soldOut: '售罄',
    tip: '请尽快完成操作，以确认订单',
    passenger: {
      count: '乘车人数',
      representative: '参加者代表',
      representativeTip: '（只需填一位乘车代表者的信息）',
      lastName: '姓氏（拼音）',
      firstName: '名字（拼音）',
      email: '联系邮箱（收取订单信息）'
    }
  },
  bookConfirm: {
    paymentInfo: '支付信息',
    paymentConfirmation: {
      warningTitle: '请确认取消政策：',
      warningText: '该商品一旦购买将无法退款。',
      agreementText: '我已确认并同意'
    },
    paymentAmount: {
      total: '合计',
      details: '详细',
      note: '日元以外的币种金额为依据当前汇率计算的预估金额，与实际扣款金额可能略有差异，仅供参考。'
    }
  },
  bookResult: {
    successMessage: '预约已完成，\n请进入订单详情查看出票结果。'
  }
};
